import React from "react";
import {AirlineLogoLargeMulticolorIcon} from "../../../../assets/svg/airline-logo-large-multicolor.icon";

export const BoardingPassCarrierLogoComponent: React.FC = () => {

    return (
        <AirlineLogoLargeMulticolorIcon/>
    )
};
